import { atom } from 'recoil';

// null (no active hold) | { minutes, seconds } while useHoldCountdown is mounted
// and ticking. Written only by that hook; the sticky header just displays it.
export const holdCountdownState = atom({
  key: 'holdCountdownState',
  default: null,
});
